import axios from 'axios';
import { isEmpty } from 'lodash';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';
import { IRegion, RegionType, IRegionDistrict, IHealthcareFacility } from '../../models/me-dashboard.model';
import { getFormattedFilterSubMenuOptions, getYearList, getMonthList, getRequestBody } from '../../utils';

export const ACTION_TYPES = {
  FETCH_REGION_LIST_BY_TYPE: 'FETCH_REGION_LIST_BY_TYPE',
  FETCH_DISPATCH_CENTER: 'FETCH_DISPATCH_CENTER',
  ALL_FETCH_HEALTHCAREFACILITY_LIST: 'ALL_FETCH_HEALTHCAREFACILITY_LIST',
  FILTER_HEALTHCAREFACILITY_BY_DISTRICT: 'FILTER_HEALTHCAREFACILITY_BY_DISTRICT',
  HEALTH_FACILITY_LEVEL: 'HEALTH_FACILITY_LEVEL',
  YEAR: 'YEAR',
  MONTH: 'MONTH',
  TRANSPORT_TYPE: 'TRANSPORT_TYPE',
  JOURNEY_TYPE: 'JOURNEY_TYPE',
  PATIENT_TYPE: 'PATIENT_TYPE',
  EMERGENCY_TYPE: 'EMERGENCY_TYPE',
  BYPASS_TYPE: 'BYPASS_TYPE',
  COUNT_REFERRALS: 'COUNT_REFERRALS',
  EMERGENCY_REFERRALS: 'EMERGENCY_REFERRALS',
  REFERRALS: 'REFERRALS',
};

const initialState = {
  loading: false,
  spinner: 0,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  region: [],
  district: [],
  council: [],
  dispatchCenter: [],
  healthFacility: [],
  allHealthFacility: [],
  healthFaciliyLevel: [],
  year: [],
  month: [],
  transportType: [],
  journeyType: [],
  patientType: [],
  emergencyType: [],
  bypassType: [],
  countReferrals: {},
  emergencyReferrals: [],
  referrals: [],
};

export type MeDashboardState = Readonly<typeof initialState>;

const COUNTRY_NAME = 'Lesotho';
const COUNTRY_ID = '9a475ef0-49f6-11eb-89d2-a85e45d05e66';

// Reducer
export default (state: MeDashboardState = initialState, action): MeDashboardState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_REGION_LIST_BY_TYPE):
    case REQUEST(ACTION_TYPES.FETCH_DISPATCH_CENTER):
    case REQUEST(ACTION_TYPES.ALL_FETCH_HEALTHCAREFACILITY_LIST):
    case REQUEST(ACTION_TYPES.COUNT_REFERRALS):
    case REQUEST(ACTION_TYPES.EMERGENCY_REFERRALS):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
        spinner: state.spinner + 1,
      };
    case REQUEST(ACTION_TYPES.REFERRALS):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
        spinner: state.spinner + 1,
      };
    case FAILURE(ACTION_TYPES.FETCH_REGION_LIST_BY_TYPE):
    case FAILURE(ACTION_TYPES.FETCH_DISPATCH_CENTER):
    case FAILURE(ACTION_TYPES.ALL_FETCH_HEALTHCAREFACILITY_LIST):
    case FAILURE(ACTION_TYPES.COUNT_REFERRALS):
    case FAILURE(ACTION_TYPES.EMERGENCY_REFERRALS):
      return {
        ...state,
        loading: false,
        spinner: state.spinner - 1,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case FAILURE(ACTION_TYPES.REFERRALS):
      return {
        ...state,
        loading: false,
        spinner: state.spinner - 1,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };

    case SUCCESS(ACTION_TYPES.FETCH_REGION_LIST_BY_TYPE):
      return {
        ...state,
        loading: false,
        spinner: state.spinner - 1,
        region: getFormattedFilterSubMenuOptions(action.payload.data['REGION'].filter(el => el['parentName'] === COUNTRY_NAME)),
        district: getFormattedFilterSubMenuOptions(action.payload.data['DISTRICT'].filter(el => el['parentName'] === COUNTRY_NAME)),
        council: getFormattedFilterSubMenuOptions(
          action.payload.data['COUNCIL'].filter(council => {
            const districts = action.payload.data['DISTRICT'].filter(el => el['parentName'] === COUNTRY_NAME);
            const filteredCouncils = districts.filter(district => council.parentId === district.id);
            return filteredCouncils;
          })
        ),
      };
    case SUCCESS(ACTION_TYPES.FETCH_DISPATCH_CENTER):
      return {
        ...state,
        loading: false,
        spinner: state.spinner - 1,
        dispatchCenter: getFormattedFilterSubMenuOptions(action.payload.data.filter(el => el['countryId'] === COUNTRY_ID)),
      };
    case SUCCESS(ACTION_TYPES.ALL_FETCH_HEALTHCAREFACILITY_LIST):
      return {
        ...state,
        loading: false,
        spinner: state.spinner - 1,
        healthFacility: getFormattedFilterSubMenuOptions(
          action.payload.data.filter(el => el.countryId === COUNTRY_ID)
        ),
        allHealthFacility: getFormattedFilterSubMenuOptions(
          action.payload.data.filter(el => el.countryId === COUNTRY_ID)
        )
      };
    case ACTION_TYPES.FILTER_HEALTHCAREFACILITY_BY_DISTRICT:
      return {
        ...state,
        healthFacility: action.payload === '*' ? state.allHealthFacility :
          state.allHealthFacility.filter(el => action.payload.includes(el['value']['districtId']))
      };
    case SUCCESS(ACTION_TYPES.COUNT_REFERRALS):
      return {
        ...state,
        loading: false,
        spinner: state.spinner - 1,
        countReferrals: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.EMERGENCY_REFERRALS):
      return {
        ...state,
        loading: false,
        spinner: state.spinner - 1,
        emergencyReferrals: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.REFERRALS):
      return {
        ...state,
        loading: false,
        spinner: state.spinner - 1,
        referrals: action.payload.data,
      };
    case ACTION_TYPES.HEALTH_FACILITY_LEVEL:
      return {
        ...state,
        loading: false,
        healthFaciliyLevel: getFormattedFilterSubMenuOptions(action.payload),
      };
    case ACTION_TYPES.YEAR:
      return {
        ...state,
        loading: false,
        year: action.payload,
      };
    case ACTION_TYPES.MONTH:
      return {
        ...state,
        loading: false,
        month: action.payload,
      };
    case ACTION_TYPES.TRANSPORT_TYPE:
      return {
        ...state,
        loading: false,
        transportType: getFormattedFilterSubMenuOptions(action.payload),
      };
    case ACTION_TYPES.JOURNEY_TYPE:
      return {
        ...state,
        loading: false,
        journeyType: getFormattedFilterSubMenuOptions(action.payload),
      };
    case ACTION_TYPES.PATIENT_TYPE:
      return {
        ...state,
        loading: false,
        patientType: getFormattedFilterSubMenuOptions(action.payload),
      };
    case ACTION_TYPES.EMERGENCY_TYPE:
      return {
        ...state,
        loading: false,
        emergencyType: getFormattedFilterSubMenuOptions(action.payload),
      };
    case ACTION_TYPES.BYPASS_TYPE:
      return {
        ...state,
        loading: false,
        bypassType: getFormattedFilterSubMenuOptions(action.payload),
      };
    default:
      return state;
  }
};

// Actions

export const getRegionsByType = () => {
  const apiUrl = 'api/regions';
  const requestUrl = `${apiUrl}/all-grouped-by-type`;
  return {
    type: ACTION_TYPES.FETCH_REGION_LIST_BY_TYPE,
    payload: axios.get<Map<RegionType, IRegion[]>>(`${requestUrl}?cacheBuster=${new Date().getTime()}`),
  };
};

export const getDispatchCenters = () => {
  const requestUrl = `${'api/getAllDispatchCenter'}`;
  return {
    type: ACTION_TYPES.FETCH_DISPATCH_CENTER,
    payload: axios.get<IRegionDistrict>(requestUrl),
  };
};

export const getAllFacility = (parentCountryId = '') => {
  const apiUrl = 'api/healthcare-facilities/compact';
  const countryId = parentCountryId || COUNTRY_ID;
  const requestUrl = `${apiUrl}?countryId=${countryId}`;
  return {
    type: ACTION_TYPES.ALL_FETCH_HEALTHCAREFACILITY_LIST,
    payload: axios.get<IHealthcareFacility>(`${requestUrl}`),
  };
};

export const filterFacilityByDistrict = (districtIds) => {
  if (districtIds.length > 0 || districtIds === '*') {
    return {
      type: ACTION_TYPES.FILTER_HEALTHCAREFACILITY_BY_DISTRICT,
      payload: districtIds,
    };
  }
};

export const getHealthFacilityLevel = () => {
  return {
    type: ACTION_TYPES.HEALTH_FACILITY_LEVEL,
    payload: [
      { name: '1', value: '1' },
      { name: '2', value: '2' },
      { name: '3', value: '3' },
    ],
  };
};

export const getYear = () => {
  return {
    type: ACTION_TYPES.YEAR,
    payload: getYearList(),
  };
};

export const getMonth = () => {
  return {
    type: ACTION_TYPES.MONTH,
    payload: getMonthList(),
  };
};

export const getTransportType = () => {
  return {
    type: ACTION_TYPES.TRANSPORT_TYPE,
    payload: [
      { name: 'Ambulance', value: 'AMBULANCE' },
      { name: 'Driver', value: 'DRIVER' },
    ],
  };
};

export const getJourneyType = () => {
  return {
    type: ACTION_TYPES.JOURNEY_TYPE,
    payload: [
      { name: 'Community to HF', value: 'Community to HF' },
      { name: 'HF to HF', value: 'HF to HF' },
    ],
  };
};

export const getPatientType = () => {
  return {
    type: ACTION_TYPES.PATIENT_TYPE,
    payload: [
      { name: 'Mother', value: 'MOTHER' },
      { name: 'Baby', value: 'BABY' },
      { name: 'Both', value: 'BOTH' },
      { name: 'Other', value: 'OTHER' },
    ],
  };
};

export const getEmergencyType = () => {
  return {
    type: ACTION_TYPES.EMERGENCY_TYPE,
    payload: [
      { name: 'Antepartum', value: 'ANTEPARTUM' },
      { name: 'Labour', value: 'LABOUR' },
      { name: 'Postpartum', value: 'POSTPARTUM' },
      { name: 'Neonatal', value: 'NEONATAL' },
    ],
  };
};

export const getBypassType = () => {
  return {
    type: ACTION_TYPES.BYPASS_TYPE,
    payload: [
      { name: 'True', value: 'TRUE' },
      { name: 'False', value: 'FALSE' },
    ],
  };
};

export const getTotalReferralsPerMonth = filterOptions => {
  const requestUrl = `api/emergencyReferrals?countryId=${COUNTRY_ID}`;
  let requestBody: object;

  if (isEmpty(filterOptions)) {
    requestBody = {
      year: ["2023"]
    };
  } else {
    requestBody = getRequestBody(filterOptions);
  }

  return {
    type: ACTION_TYPES.EMERGENCY_REFERRALS,
    payload: axios.post(requestUrl, requestBody),
  };
};

export const getTotalReferrals = filterOptions => {
  const requestUrl = `api/referrals?countryId=${COUNTRY_ID}`;
  let requestBody: object;

  if (isEmpty(filterOptions)) {
    requestBody = {
      year: ["2023"]
    };
  } else {
    requestBody = getRequestBody(filterOptions);
  }

  return {
    type: ACTION_TYPES.REFERRALS,
    payload: axios.post(requestUrl, requestBody),
  };
};

export const getCountReferrals = filterOptions => {
  const requestUrl = `api/count-referrals?countryId=${COUNTRY_ID}`;
  let requestBody: object;

  if (isEmpty(filterOptions)) {
    requestBody = {
      year: ["2023"]
    };
  } else {
    requestBody = getRequestBody(filterOptions);
  }

  return {
    type: ACTION_TYPES.COUNT_REFERRALS,
    payload: axios.post(requestUrl, requestBody),
  };
};
